var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component, Fragment } from 'react';
import { injectIntl } from 'react-intl';
import { Form } from 'react-final-form';
import PaymentMethodSelector from '../../Payment/PaymentMethodSelector';
import SelectedPaymentMethod from '../../Payment/SelectedPaymentMethod';
import * as PaymentAccountForms from '../../Payment/PaymentAccountForms';
import Money from '../../../../components/Money';
import { getSupportedAmounts } from '../../Payment';
import BonusCodeInput from '../BonusCodeInput';
import { matchProviderType, getPaymentForm } from '../../Payment';
import Icon from '../../../../components/Icon';
import marked from 'marked';
import Input from '../../../../components/Input';
import PaymentAmountSelector from '../../Payment/PaymentAmountSelector';
import MethodMinMax from '../../Payment/MethodMinMax';
import DelayVisibility from '../../../../components/Deposit/DelayVisibility';
import AccountSelection from '../../Payment/AccountSelection';
import swishParser from '../../../../lib/utils/swishParser';
import muchBetterParser from '../../../../lib/utils/muchBetterParser';
import Button from '../../Payment/Button';
import Translate from '../../../../components/Translate';
import translate from '../../../../lib/utils/translate';

var STEPS = {
  SELECT_PAYMENT_METHOD: 'SELECT_PAYMENT_METHOD',
  FILL_IN: 'FILL_IN'
};

var SelectedBonus = function SelectedBonus(_ref) {
  var selectedBonus = _ref.selectedBonus,
      onClick = _ref.onClick;
  return React.createElement(
    'div',
    { className: 'SelectedBonus' },
    React.createElement(
      'div',
      { className: 'bonus-name' },
      selectedBonus && (selectedBonus.content ? selectedBonus.content.name : selectedBonus.Name),
      React.createElement(Icon, { icon: 'check' })
    ),
    React.createElement(
      'div',
      { className: 'select-new-bonus' },
      React.createElement(Icon, { icon: 'angle-right' }),
      React.createElement(
        Translate,
        {
          id: 'label.select-new-bonus',
          defaultMessage: 'Select a new bonus' },
        function (msg) {
          return React.createElement(
            'span',
            { onClick: onClick },
            msg
          );
        }
      )
    )
  );
};

var DepositWidget = function (_Component) {
  _inherits(DepositWidget, _Component);

  function DepositWidget(props) {
    _classCallCheck(this, DepositWidget);

    var _this = _possibleConstructorReturn(this, (DepositWidget.__proto__ || Object.getPrototypeOf(DepositWidget)).call(this, props));

    _initialiseProps.call(_this);

    var _this$props = _this.props,
        currency = _this$props.currency,
        methods = _this$props.methods,
        bonusCode = _this$props.bonusCode,
        fromWelcome = _this$props.fromWelcome,
        initialState = _this$props.initialState,
        paymentStats = _this$props.paymentStats,
        remainingDepositLimit = _this$props.remainingDepositLimit,
        user = _this$props.user,
        payments = _this$props.payments;


    var currentStep = initialState && initialState.currentStep ? initialState.currentStep : STEPS.SELECT_PAYMENT_METHOD;

    var selectedMethod = initialState && initialState.selectedMethod ? initialState.selectedMethod : methods[0] || { accounts: [], limit: {}, providerType: '' };

    var selectedAccount = initialState && initialState.selectedAccount ? initialState.selectedAccount : selectedMethod.accounts.length ? selectedMethod.accounts[0] : {};

    var selectedMethodDetail = payments.find(function (payment) {
      return matchProviderType(payment, selectedMethod);
    });

    var amounts = getSupportedAmounts({
      currency: currency,
      providerType: selectedMethod.providerType,
      lastDepositAmount: paymentStats.LastDepositAmount,
      remainingDepositLimit: remainingDepositLimit,
      methodMin: selectedMethod.limit.min,
      methodMax: selectedMethod.limit.max,
      customAmount: selectedMethodDetail && selectedMethodDetail.customAmounts,
      cancelWithdrawalAmount: selectedMethod.amount,
      spainRemainingDepositAmount: _this.getSpainRemainingDepositAmount()
    });

    var currentAmount = initialState && initialState.currentAmount ? initialState.currentAmount : undefined;

    bonusCode = initialState && initialState.bonusCode ? initialState.bonusCode : bonusCode;

    var preDepositBonus = initialState && initialState.preDepositBonus ? initialState.preDepositBonus : undefined;

    _this.state = {
      currentStep: currentStep,
      selectedMethod: selectedMethod,
      selectedAccount: selectedAccount,
      newAccount: false,
      currentAmount: currentAmount,
      amounts: amounts,
      bonusCode: bonusCode,
      showBonusSlider: !fromWelcome,
      preDepositBonus: preDepositBonus,
      buttonLoading: null,
      swishNumber: user && user.MobilePhoneNumber,
      siruNumber: user && user.MobilePhoneNumber
    };
    return _this;
  }

  _createClass(DepositWidget, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // Update state when the bonus code updates in props
      if (this.props.bonusCode !== prevProps.bonusCode) {
        this.setState({
          bonusCode: this.props.bonusCode
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          selectedAccount = _state.selectedAccount,
          selectedMethod = _state.selectedMethod,
          currentAmount = _state.currentAmount,
          amounts = _state.amounts,
          bonusCode = _state.bonusCode,
          showBonusSlider = _state.showBonusSlider,
          currentStep = _state.currentStep,
          preDepositBonus = _state.preDepositBonus;
      var _props = this.props,
          headers = _props.headers,
          methods = _props.methods,
          payments = _props.payments,
          currency = _props.currency,
          country = _props.country,
          intl = _props.intl,
          renderError = _props.renderError,
          initialState = _props.initialState,
          bonuses = _props.bonuses,
          bonusSlider = _props.bonusSlider,
          remainingDepositLimit = _props.remainingDepositLimit,
          renderDepositLimitNotice = _props.renderDepositLimitNotice,
          renderNotVerifiedNotice = _props.renderNotVerifiedNotice,
          renderCanceledNotice = _props.renderCanceledNotice,
          renderAllowBonusWarning = _props.renderAllowBonusWarning,
          paymentStats = _props.paymentStats,
          _props$shouldAutoFocu = _props.shouldAutoFocus,
          shouldAutoFocus = _props$shouldAutoFocu === undefined ? false : _props$shouldAutoFocu,
          hideSelectedBonus = _props.hideSelectedBonus,
          config = _props.config;


      var accountExclusions = payments.filter(function (provider) {
        return provider.accountSelection;
      }).map(function (provider) {
        return provider.providerType.toUpperCase();
      });
      var bonusExclusions = payments.filter(function (provider) {
        return provider.bonusInput;
      }).map(function (provider) {
        return provider.providerType.toUpperCase();
      });
      var customAmountExclusions = [].concat(_toConsumableArray(payments.filter(function (provider) {
        return provider.hideCustomAmount;
      }).map(function (provider) {
        return provider.providerType.toLowerCase();
      })), ['reversewithdrawal']);
      var minMaxExclusions = ['reversewithdrawal'];

      var minDepositBonusAmount = this.getMinDepositBonusAmount();

      var paymentDetail = PaymentAccountForms[getPaymentForm(selectedMethod)];

      var selectedMethodDetail = payments.find(function (payment) {
        return matchProviderType(payment, selectedMethod);
      });

      var selectedBonus = bonuses.find(function (b) {
        return b.PromoCode === bonusCode;
      });
      var BonusSlider = bonusSlider;

      var footer = headers && headers.find(function (s) {
        return s.identifier === 'deposit-step-SELECT_PAYMENT_METHOD-footer';
      });

      if (currentStep === STEPS.SELECT_PAYMENT_METHOD) {
        // prettier-ignore
        var shouldRenderRemainingDepositLimitNotice = selectedMethod.providerType.toLowerCase() !== 'reversewithdrawal' && renderDepositLimitNotice && remainingDepositLimit > 0 && (remainingDepositLimit <= paymentStats.LastDepositAmount * 3 || this.state.amountIsAboveRemainingDepositLimit);

        var submitBtnText = paymentDetail ? translate({ id: 'label.continue' }, intl) : translate({ id: 'label.submit_deposit' }, intl);

        var showBonus = !bonusExclusions.includes(selectedMethod.providerType.toUpperCase());

        var showMinMax = !minMaxExclusions.includes(selectedMethod.providerType.toLowerCase());

        return React.createElement(
          'div',
          { className: 'select-payment-method' },
          bonuses.length > 0 && BonusSlider && (showBonusSlider ? React.createElement(BonusSlider, {
            bonuses: bonuses,
            onSelect: this.onSelectBonus,
            selectedBonus: selectedBonus
          }) : !hideSelectedBonus ? React.createElement(SelectedBonus, {
            selectedBonus: selectedBonus,
            onClick: function onClick() {
              _this2.onSelectBonus('');
              _this2.setState({ showBonusSlider: true });
            }
          }) : null),
          React.createElement(Form, {
            onSubmit: this.handleNextStep,
            initialValues: {
              amount: currentAmount,
              bonusCode: bonusCode
            },
            validate: function validate(_ref2) {
              var amount = _ref2.amount;

              var errors = { amount: [] };

              if (!_this2.state.amountIsAboveRemainingDepositLimit && remainingDepositLimit && amount > remainingDepositLimit) {
                _this2.setState({ amountIsAboveRemainingDepositLimit: true });
              }

              if (amount === undefined || amount === '') {
                return errors;
              }

              if (amount < parseFloat(selectedMethod.limit.min) || amount < parseFloat(_this2.getMinDepositBonusAmount())) {
                errors.amount.push(React.createElement(Translate, {
                  id: 'error.cashier.amount-below-method-limit',
                  defaultMessage: 'Amount is too low. Min amount: {min}',
                  values: {
                    min: Math.min(parseFloat(selectedMethod.limit.min), parseFloat(_this2.getMinDepositBonusAmount()))
                  }
                }));
                return errors;
              }

              var spainRemainingDepositAmount = _this2.getSpainRemainingDepositAmount();
              if (amount > parseFloat(selectedMethod.limit.max) || remainingDepositLimit !== false && amount > remainingDepositLimit || spainRemainingDepositAmount !== false && spainRemainingDepositAmount - parseFloat(amount) < 0) {
                errors.amount.push(React.createElement(Translate, {
                  id: 'error.cashier.amount-above-method-limit',
                  defaultMessage: 'Amount is too high.'
                }));
                return errors;
              }

              if (remainingDepositLimit !== false && amount > remainingDepositLimit) {
                return errors;
              }

              return undefined;
            },
            render: function render(_ref3) {
              var handleSubmit = _ref3.handleSubmit,
                  invalid = _ref3.invalid,
                  errors = _ref3.errors;
              return React.createElement(
                'form',
                {
                  onSubmit: function onSubmit(values) {
                    _this2.setState({ buttonLoading: 'method-submit' });
                    handleSubmit(values);
                  },
                  autoComplete: 'off' },
                React.createElement(PaymentMethodSelector, {
                  methods: methods,
                  currency: currency,
                  payments: payments,
                  selectedMethod: selectedMethod,
                  selectedAccount: selectedAccount,
                  onSelectMethod: _this2.onSelectMethod,
                  onDeleteAccount: _this2.onDeleteAccount,
                  methodContent: function methodContent(method) {
                    if (method.txType !== selectedMethod.txType || method.service !== selectedMethod.service) return null;

                    return React.createElement(
                      Fragment,
                      null,
                      renderError && renderError(),
                      shouldRenderRemainingDepositLimitNotice && renderDepositLimitNotice(remainingDepositLimit),
                      renderNotVerifiedNotice && renderNotVerifiedNotice(currentAmount),
                      renderCanceledNotice && renderCanceledNotice(),
                      renderAllowBonusWarning && renderAllowBonusWarning(selectedMethodDetail, _this2.state.bonusCode),
                      selectedMethod.txType === 'SwishDeposit' && React.createElement(Input, {
                        className: 'swish-number',
                        name: 'swishNumber',
                        type: 'tel',
                        placeholder: translate({
                          id: 'label.mobile_number_placeholder',
                          defaultMessage: 'eg. 0701234567'
                        }, intl),
                        value: _this2.state.swishNumber,
                        title: translate({
                          id: 'label.mobile_number'
                        }, intl),
                        onChange: function onChange(e) {
                          return _this2.setState({ swishNumber: e.target.value });
                        },
                        required: true
                      }),
                      !accountExclusions.includes(selectedMethod.providerType) && selectedMethod.accounts.length > 0 && React.createElement(AccountSelection, {
                        selectedAccount: selectedAccount,
                        accounts: selectedMethod.accounts,
                        onChange: _this2.onSelectAccount,
                        canAddAccount: selectedMethod && selectedMethod.canAddAccount
                      }),
                      amounts && React.createElement(PaymentAmountSelector, {
                        amounts: amounts,
                        onClick: function onClick(_ref4) {
                          var amount = _ref4.amount;
                          return _this2.handleNextStep({ amount: amount, bonusCode: bonusCode });
                        },
                        disabled: selectedMethod.txType === 'SwishDeposit' && _this2.state.swishNumber && _this2.state.swishNumber.length === 0,
                        currency: currency,
                        buttonLoading: _this2.state.buttonLoading,
                        setButtonLoading: function setButtonLoading(buttonLoading) {
                          return _this2.setState({ buttonLoading: buttonLoading });
                        }
                      }),
                      !customAmountExclusions.includes(selectedMethod.providerType.toLowerCase()) && React.createElement(
                        'div',
                        { className: 'custom-amount-and-submit' },
                        React.createElement(Input, {
                          required: true,
                          pattern: '[0-9]*',
                          className: 'custom-amount',
                          name: 'amount',
                          type: 'number',
                          step: '0.01',
                          label: translate({
                            id: 'label.amount'
                          }, intl),
                          status: errors && errors.amount && errors.amount.length ? 'failure' : '',
                          value: currentAmount,
                          onChange: function onChange(e) {
                            return _this2.setState({
                              currentAmount: e.target.value
                            });
                          },
                          autoFocus: shouldAutoFocus,
                          setRef: function setRef(ref) {
                            return _this2.amountInputRef = ref;
                          }
                        }),
                        React.createElement(
                          Button,
                          {
                            className: 'button secondary',
                            disabled: invalid || _this2.state.buttonLoading === 'method-submit',
                            isLoading: _this2.state.buttonLoading === 'method-submit',
                            type: 'submit' },
                          submitBtnText
                        ),
                        errors && errors.amount && errors.amount.length > 0 && React.createElement(
                          DelayVisibility,
                          null,
                          React.createElement(
                            'div',
                            { className: 'error-message' },
                            errors.amount
                          )
                        )
                      ),
                      React.createElement(
                        'div',
                        { className: 'bonus-limit' },
                        !minMaxExclusions.includes(selectedMethod.providerType.toLowerCase()) && !customAmountExclusions.includes(selectedMethod.providerType.toLowerCase()) && selectedMethod && selectedMethod.limit && React.createElement(MethodMinMax, {
                          method: selectedMethod,
                          currency: currency,
                          minDepositBonusAmount: minDepositBonusAmount,
                          remainingDepositLimit: remainingDepositLimit,
                          spainRemainingDepositAmount: _this2.getSpainRemainingDepositAmount()
                        }),
                        !bonusExclusions.includes(selectedMethod.providerType) && React.createElement(BonusCodeInput, {
                          disabled: preDepositBonus || !showBonusSlider,
                          bonusCode: bonusCode,
                          onChange: _this2.updateBonusCode,
                          status: !!selectedBonus && 'active'
                        })
                      )
                    );
                  }
                })
              );
            }
          }),
          footer && footer.content && React.createElement('div', {
            className: 'footer',
            dangerouslySetInnerHTML: { __html: marked(footer.content) }
          })
        );
      }

      if (currentStep === STEPS.FILL_IN) {
        var header = headers && headers.find(function (h) {
          return h.identifier === 'deposit-step-FILL_IN';
        });

        var content = selectedMethodDetail.depositFillContent && selectedMethodDetail.depositFillContent[0];

        var paymentAccountFormProps = {
          account: selectedAccount,
          method: selectedMethod,
          detail: selectedMethodDetail,
          country: country,
          config: config
        };
        var PaymentAccountForm = paymentDetail ? paymentDetail.component : null;

        var defaultAccountData = paymentDetail ? paymentDetail.parser(selectedAccount) : selectedAccount;

        // in the case got error use the previous data
        if (initialState) {
          defaultAccountData = initialState.accountData;
        }

        // Add initial values for payment form
        if (paymentDetail && paymentDetail.initialValues) {
          defaultAccountData = _extends({}, defaultAccountData, paymentDetail.initialValues(paymentAccountFormProps));
        }

        if (selectedMethod.providerType.toLowerCase() === 'siru' && selectedMethod.accounts.length === 0) {
          defaultAccountData.phoneNumber = this.state.siruNumber;
        }

        return React.createElement(
          Fragment,
          null,
          content && content.content ? React.createElement('header', {
            dangerouslySetInnerHTML: { __html: marked(content.content) }
          }) : header && header.content ? React.createElement('header', {
            dangerouslySetInnerHTML: { __html: marked(header.content) }
          }) : null,
          React.createElement(Form, {
            initialValues: defaultAccountData,
            onSubmit: this.onSubmit,
            render: function render(_ref5) {
              var handleSubmit = _ref5.handleSubmit,
                  values = _ref5.values,
                  change = _ref5.change,
                  form = _ref5.form;
              return React.createElement(
                Fragment,
                null,
                React.createElement(
                  'form',
                  {
                    onSubmit: function onSubmit(values) {
                      _this2.setState({ buttonLoading: 'fill-in-submit' });
                      handleSubmit(values);
                    },
                    className: 'fill-in-steps' },
                  React.createElement(SelectedPaymentMethod, {
                    currency: currency,
                    selectedMethod: selectedMethod,
                    detail: selectedMethodDetail,
                    handleBack: _this2.handleBackStep
                  }),
                  renderError && renderError(),
                  React.createElement(
                    'div',
                    { className: 'account-fill-in' },
                    React.createElement(
                      'div',
                      { className: 'account-details' },
                      React.createElement(PaymentAccountForm, _extends({}, paymentAccountFormProps, {
                        change: form.change,
                        values: values
                      }))
                    ),
                    React.createElement(
                      Button,
                      {
                        className: 'button secondary wide',
                        disabled: _this2.state.buttonLoading === 'fill-in-submit',
                        isLoading: _this2.state.buttonLoading === 'fill-in-submit',
                        type: 'submit' },
                      translate({ id: 'label.submit_deposit' }, intl),
                      ' ',
                      React.createElement(Money, {
                        value: currentAmount,
                        currency: currency,
                        minimumFractionDigits: currentAmount % 1 === 0 ? 0 : 2,
                        maximumFractionDigits: currentAmount % 1 === 0 ? 0 : 2
                      })
                    )
                  )
                ),
                selectedMethod.canAddAccount && !_this2.state.newAccount && React.createElement(
                  'div',
                  {
                    className: 'add-new-account',
                    onClick: function onClick() {
                      _this2.setState({
                        selectedAccount: {},
                        newAccount: true
                      }, function () {
                        _this2.props.clearError();
                        Object.keys(values).forEach(function (inputVal) {
                          return change(inputVal, '');
                        });
                      });
                    } },
                  React.createElement(Icon, { icon: 'plus' }),
                  React.createElement(Translate, {
                    id: 'action.cashier.add-new-account',
                    defaultMessage: 'Add new account'
                  })
                )
              );
            }
          })
        );
      }
    }
  }]);

  return DepositWidget;
}(Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleNextStep = function (_ref6) {
    var amount = _ref6.amount,
        bonusCode = _ref6.bonusCode;
    var _state2 = _this3.state,
        selectedMethod = _state2.selectedMethod,
        preDepositBonus = _state2.preDepositBonus,
        selectedAccount = _state2.selectedAccount;


    var formExists = !!PaymentAccountForms[getPaymentForm(selectedMethod)];
    var skipFillInStep = ['skrill', 'bestpay', 'jeton', 'bankiban', 'bankintl'];

    if (!formExists || selectedAccount.accountId && skipFillInStep.includes(selectedMethod.providerType.toLowerCase())) {
      return _this3.onSubmit({
        currentAmount: amount,
        bonusCode: bonusCode,
        preDepositBonus: preDepositBonus
      });
    }

    _this3.setState({
      currentAmount: amount,
      bonusCode: bonusCode,
      currentStep: STEPS.FILL_IN,
      newAccount: _this3.state.newAccount || selectedMethod.accounts.length === 0
    });
  };

  this.handleBackStep = function () {
    var _state3 = _this3.state,
        currentStep = _state3.currentStep,
        buttonLoading = _state3.buttonLoading;


    if (buttonLoading === 'fill-in-submit') return null;

    if (currentStep === STEPS.FILL_IN) {
      _this3.setState({
        currentStep: STEPS.SELECT_PAYMENT_METHOD,
        buttonLoading: null,
        newAccount: false
      });
    }

    _this3.props.reset();
  };

  this.onSubmit = function (data) {
    var _props2 = _this3.props,
        onSubmit = _props2.onSubmit,
        countries = _props2.countries,
        user = _props2.user;
    var _state4 = _this3.state,
        selectedMethod = _state4.selectedMethod,
        swishNumber = _state4.swishNumber;


    var submitData = _extends({}, _this3.state, data);

    if (submitData.expiryDate) {
      submitData.expiryMonth = submitData.expiryDate.substring(0, 2);
      submitData.expiryYear = '20' + submitData.expiryDate.substring(3, 5);
    }

    if (selectedMethod.txType === 'SwishDeposit' && swishNumber > 0) {
      submitData.swishNumber = swishParser(swishNumber);
      delete submitData.selectedAccount.accountId;
    }

    if (data.phoneNumber) {
      _this3.setState({ siruNumber: data.phoneNumber });
    }

    if (selectedMethod.txType === 'MuchBetterDeposit') {
      var country = countries && countries.find(function (c) {
        return c.value === user.Country;
      });
      submitData.phoneNumber = muchBetterParser(submitData.phoneNumber, country && country.callingCode);
    }

    return Promise.resolve(onSubmit(submitData)).then(function () {
      _this3.setState({ buttonLoading: null });
    });
  };

  this.onSelectMethod = function (_ref7) {
    var method = _ref7.method;
    var _props3 = _this3.props,
        currency = _props3.currency,
        paymentStats = _props3.paymentStats,
        remainingDepositLimit = _props3.remainingDepositLimit,
        payments = _props3.payments,
        shouldAutoFocus = _props3.shouldAutoFocus;


    if (shouldAutoFocus) {
      setTimeout(function () {
        _this3.amountInputRef && _this3.amountInputRef.focus();
      }, 1);
    }

    var selectedMethodDetail = payments.find(function (payment) {
      return matchProviderType(payment, method);
    });

    var amounts = getSupportedAmounts({
      currency: currency,
      providerType: method.providerType,
      lastDepositAmount: paymentStats.LastDepositAmount,
      remainingDepositLimit: remainingDepositLimit,
      methodMin: method.limit.min,
      methodMax: method.limit.max,
      customAmount: selectedMethodDetail && selectedMethodDetail.customAmounts,
      cancelWithdrawalAmount: method.amount,
      spainRemainingDepositAmount: _this3.getSpainRemainingDepositAmount()
    });

    _this3.setState({
      selectedMethod: method,
      selectedAccount: method.accounts.length ? method.accounts[0] : {},
      amounts: amounts,
      amountIsAboveRemainingDepositLimit: false
    }, function () {
      return _this3.props.reset();
    });
  };

  this.onSelectAccount = function (account) {
    _this3.setState({
      selectedAccount: account || {},
      newAccount: !(account && account.accountId)
    });
  };

  this.onSelectBonus = function (bonusCode) {
    if (bonusCode === _this3.state.bonusCode) {
      bonusCode = '';
    }

    _this3.setState({
      currentStep: STEPS.SELECT_PAYMENT_METHOD,
      preDepositBonus: !!bonusCode,
      bonusCode: bonusCode
    });
  };

  this.updateBonusCode = function (e) {
    _this3.setState({
      bonusCode: e.target.value
    });
  };

  this.onDeleteAccount = function (account) {
    _this3.props.onDeleteAccount(account);
  };

  this.getMinDepositBonusAmount = function () {
    var _props4 = _this3.props,
        bonuses = _props4.bonuses,
        currency = _props4.currency;
    var bonusCode = _this3.state.bonusCode;


    var selectedBonus = bonuses.find(function (b) {
      return b.PromoCode === bonusCode;
    });

    var reward = selectedBonus && selectedBonus.Rewards && selectedBonus.Rewards[0].CurrencyAmounts.find(function (c) {
      return c.Currency === currency;
    });
    // Find the lowest min deposit amount in the bonus rewards
    var minDepositBonusAmount = reward && reward.MinDepositAmount && selectedBonus.Rewards.reduce(function (minDepositAmount, reward) {
      var rewardMinDepositAmount = reward.CurrencyAmounts.find(function (c) {
        return c.Currency === currency;
      }).MinDepositAmount;
      return rewardMinDepositAmount < minDepositAmount ? rewardMinDepositAmount : minDepositAmount;
    }, reward.MinDepositAmount);

    return minDepositBonusAmount;
  };

  this.getSpainRemainingDepositAmount = function () {
    var _props5 = _this3.props,
        jurisdiction = _props5.jurisdiction,
        hasIdApproved = _props5.hasIdApproved,
        paymentStats = _props5.paymentStats;

    return jurisdiction.toLowerCase() === 'es' && !hasIdApproved && (150 - parseFloat(paymentStats.TotalDeposit) < 0 ? 0 : 150 - parseFloat(paymentStats.TotalDeposit));
  };
};

export default injectIntl(DepositWidget);